import React, { useState } from 'react';
import '../components/styles/contact.css';
import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../config/firebase'; // Make sure this path matches your firebase config file location

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    message: '',
    additionalDetails: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // Add the message to Firestore
      const docRef = await addDoc(collection(db, "messages"), {
        ...formData,
        createdAt: serverTimestamp(),
        status: "unread"
      });

      console.log("Message sent with ID:", docRef.id);

      // Reset form
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        message: '',
        additionalDetails: '',
      });

      setSubmitStatus({
        type: 'success',
        message: 'Thank you for your message! We will get back to you soon.',
      });
    } catch (error) {
      console.error('Error:', error);
      setSubmitStatus({
        type: 'error',
        message: 'There was an error sending your message. Please try again later.',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        {/* Left Column - Form */}
        <div className="contact-left">
          <form onSubmit={handleSubmit} className="contact-form">
            {submitStatus && (
              <div className={`submit-status ${submitStatus.type}`}>
                {submitStatus.message}
              </div>
            )}
            
            <div className="name-fields">
              <div className="form-group">
                <label>First Name</label>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                  disabled={isSubmitting}
                />
              </div>
              <div className="form-group">
                <label>Last Name</label>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                  disabled={isSubmitting}
                />
              </div>
            </div>

            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                disabled={isSubmitting}
              />
            </div>

            <div className="form-group">
              <label>Message</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                disabled={isSubmitting}
                rows="4"
              />
            </div>

            <div className="form-group">
              <label>Additional Details</label>
              <textarea
                name="additionalDetails"
                value={formData.additionalDetails}
                onChange={handleChange}
                disabled={isSubmitting}
                rows="4"
              />
            </div>

            <button 
              type="submit" 
              className="send-message-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        </div>

        {/* Right Column - Help Section */}
        <div className="contact-right">
          <div className="help-section">
            <h2>How Can We Help?</h2>
            <p>
              Please select a topic below related to your inquiry. If you don't find what you need, fill out our contact form.
            </p>

            <div className="help-items">
              <a href="/booking" className="help-item-link">
                <div className="help-item">
                  <h3>Book a Consultation</h3>
                  <p>Get a Free Consultation.</p>
                </div>
              </a>

              <a href="/pricing" className="help-item-link">
                <div className="help-item">
                  <h3>View Pricing List</h3>
                  <p>View the pricing on all our Beauty Services.</p>
                </div>
              </a>

              <a href="https://www.instagram.com/makeup_by_lorren/" className="help-item-link">
                <div className="help-item">
                  <h3>Contact us on Instagram</h3>
                  <p>Talk to us on Instagram and we will get back to you ASAP.</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;